import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { Button, OptionCard, OptionCardContent, ProgressBar } from '../../components/ui';

export function RatingTypeScreen() {
  const navigate = useNavigate();
  const { onboarding, updateOnboarding, nextStep } = useStore();

  const handleSelect = (ratingType: 'psl' | 'normal') => {
    updateOnboarding({ ratingType });
  };

  const handleContinue = () => {
    if (onboarding.ratingType) {
      nextStep();
      navigate('/onboarding/gender');
    }
  };

  return (
    <div className="screen-container onboarding-screen">
      <ProgressBar current={1} total={17} className="mb-8" />

      <div className="flex-1 flex flex-col">
        <h1 className="text-3xl font-bold mb-2">What type of ratings do you want?</h1>
        <p className="text-secondary mb-8">
          Choose your scoring style. PSL includes a deeper interpretation.
        </p>

        <div className="space-y-3 mb-8">
          <OptionCard
            selected={onboarding.ratingType === 'psl'}
            onClick={() => handleSelect('psl')}
          >
            <OptionCardContent
              title="PSL Scores"
              description="PSL tiers + interpretation summary"
            />
          </OptionCard>

          <OptionCard
            selected={onboarding.ratingType === 'normal'}
            onClick={() => handleSelect('normal')}
          >
            <OptionCardContent
              title="Normal Ratings"
              description="Standard 1–100 scores only"
            />
          </OptionCard>
        </div>
      </div>

      <Button
        onClick={handleContinue}
        disabled={!onboarding.ratingType}
      >
        Continue
      </Button>
    </div>
  );
}
